/*eslint-disable */
import axios from 'axios'
import { errormessage } from './analyticsdashboard.js'
var baseurl = process.env.VUE_APP_ANALYTIC_SERVER;

async function getproductsapi(id) {
    let results = [];
    await axios.get(baseurl + "users/" + id + "/designs")
        .then(res => {
            if (res.data.length >= 1) {
                results.push({
                    label: "All",
                    value: "all"
                });
                res.data.forEach(x => {
                    results.push({
                        label: x.designname,
                        value: x.id.toString(),
                    })
                })
            } else {
                results = "NOTHING";
            }

        }).catch(error => {
            console.log(error);

        })
    return results;

}

async function getjurisdictionapi(jurmap) {
    let results = [];
    await axios.get(baseurl + "build/juristrictions")
        .then(res => {
            if (res.data.length >= 1) {
                results.push({
                    label: "All",
                    value: "all"
                });
                res.data.forEach(x => {
                    results.push({
                        label: x.uppercase,
                        value: x.lowercase,
                    })
                    jurmap.set(x.lowercase, x.uppercase);
                })
            } else {
                results = [{label: "No Jurisdiction, something is wrong", value: 0}]
            }
        }).catch(error => {
            console.log(error);
            errormessage("Error while retrieving the list of Jurisdiction")

        })
    let returnvar = [results, jurmap];
    return returnvar;
}

/*
  range = {count: Integer, type: 'week' (default)|'day'|'month',dayOffset: Int}
  for dayOffset put 6 for the ENDDATE and 7 for the STARTDATE
  returns array of Date Objects in non-decreasing order
*/
function generaterange(range) {
    range.type = typeof range.type === "undefined" ? "week" : range.type;
    let d = new Date(),
        yyyy = d.getFullYear(),
        mm = d.getMonth(),
        dd = d.getDate(),
        day = d.getDay(),
        end = range.type == "week" ? new Date(yyyy, mm, dd + (range.dayOffset - day)) : range.type == "day" ? new Date(yyyy, mm, dd) : new Date(yyyy, mm + 1, 0),
        intervals = [],
        month_names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    for (var i = 0; i < range.count; i++) {
        if (i) {
            switch (range.type) {
                case 'day':
                    end.setDate(end.getDate() - 1);
                    break;
                case 'month':
                    end.setMonth(end.getMonth() - 1);
                    break;
                default:
                    end.setDate(end.getDate() - 7);
            }
        }
        intervals.push(new Date(end));
    }
    //uncomment to get output of form [{month: "...", day: ...}, {month: "...", day: ...}, ...]
    return intervals.reverse().map(date => {
        return {month: month_names[date.getMonth()], day: date.getDate()}
    });
}

function getmonthrange(numberofmonths, longorshort) {
    let month_names;

    //Gotta do this because numberofmonths is one more than it should be. IDK why, it's to late for this hack... -Dan
    numberofmonths--;

    if (longorshort == "short") {
        month_names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    } else {
        month_names = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    }

    let date = new Date();
    let curmonth = date.getMonth();
    let curyear = date.getFullYear();
    if (curmonth === 0) {
        curmonth = 11;
        curyear--;
    } else {
        curmonth--;
    }
    let returnarr = [];

    for (let i = curmonth; numberofmonths > 0; numberofmonths--) {
        curmonth = month_names[i];
        returnarr.push({"Month": curmonth, "Year": curyear});

        i--;

        if (i === -1) {
            i = 11;
            curyear--;
        }

    }
    return returnarr;
}


async function getsinglestatapi(id, obj, designmap) {
    let returnobj = obj;
    let products = obj.selectedproducts;
    let jurs = obj.selectedjur;
    let time = obj.selectedtime;
    let productsvar = "";
    let jursvar = "";
    let timeunitvar = "";
    let timedurvar = "";

    let monthorweek = "";


    //If the products or does not include all
    if (!products.includes("all")) {
        productsvar = "&products=";
        products.forEach(x => {
            productsvar = productsvar + x + ",";
        });
    }

    if (!jurs.includes("all")) {
        jursvar = "&jurisdictions=";
        jurs.forEach(x => {
            jursvar = jursvar + x + ",";
        });
    }

    //Time check
    if (time.slice(-1) == "m") {
        timeunitvar = "&timeunit=month";
        monthorweek = "month";
    } else {
        timeunitvar = "&timeunit=week";
        monthorweek = "week";
    }
    let countint = parseInt(time.slice(0, time.length - 1)) + 1;
    let range = {count: countint, type: monthorweek, dayOffset: 6}
    let range2 = {count: countint, type: monthorweek, dayOffset: 7}
    let expecteddurationEND = null;
    let expecteddurationSTART = null;
    let monthrange = [];

    // Not all functions/vars are needed so only call the ones that are based on the time format (months or weeks)
    if (monthorweek === "month") {
        monthrange = getmonthrange(countint);
    } else {
        expecteddurationEND = generaterange(range);
        expecteddurationSTART = generaterange(range2);
    }

    timedurvar = "&timeduration=" + time.slice(0, time.length - 1);


    await axios.get(baseurl + "build/stats/indv?id=" + id + productsvar + jursvar + timedurvar + timeunitvar)
        .then(res => {

            //We need to sort the selected designs because the data from the API comes with sorted in ascending order
            //Our selected designs may not be sorted or selected in ascending order
            returnobj.selectedproducts.sort((a, b) => a - b);
            //console.log(res.data); //DEBUG
            if (monthorweek === "week") {

                let newcolumn = ['Week of'];
                returnobj.xtitle = "Week of";

                let listofdesignid = [];

                if (returnobj.selectedproducts.includes("all")) {
                    for (let x of designmap.values()) {
                        newcolumn.push(x);
                    }
                    for (let x of designmap.keys()) {
                        listofdesignid.push(parseInt(x));
                    }
                } else {
                    //Adds the designs name to the columns based on ascending design id
                    returnobj.selectedproducts.forEach(x => {
                        //console.log(x); //DEBUG
                        listofdesignid.push(parseInt(x));
                        newcolumn.push(designmap.get(x));
                    });
                }


                //console.log(newcolumn); //DEBUG
                returnobj.columns = newcolumn;

                //list of unique week numbers
                let weeknumber = [];
                //Get the unique week numbers
                res.data.forEach(x => {
                    if (!weeknumber.includes(x.WEEKNUMBER)) {
                        weeknumber.push(x.WEEKNUMBER);
                    }
                });

                //tmp vars that are useful in the for loop
                let len = listofdesignid.length;
                let weekindex = 0;

                let curexpecteddatenumber = 0;

                //Newrowvar will be swapped with the obj's current data
                let newrowvar = [];
                let currentrowweek = -1;
                //used as a tmp working row
                let row = [];

                //if there is no hits at all
                if (res.data.length === 0) {
                    let newWeekStartDate = expecteddurationSTART[curexpecteddatenumber].month + " " + expecteddurationSTART[curexpecteddatenumber].day;
                    row = [];
                    row.push(newWeekStartDate);
                    listofdesignid.forEach(() => {
                        row.push(0);
                    })
                    returnobj.rows = row;

                }
                /*
                !!!!!!!!!!!!!!
                Translate the API data to the google charts format
                 */

                for (let i = 0; i < res.data.length; i++) {
                    let curweek = res.data[i].WEEKNUMBER;
                    let curproject = res.data[i].project;
                    //Gets the end date of the week Ex: "Jun 13"
                    let curenddate = res.data[i].ENDDATE;

                    //Gets a String version of the Month + day Ex: "Jun 13"
                    //Currently curdate is the END Day of the week
                    let curdate = expecteddurationEND[curexpecteddatenumber].month + " " + expecteddurationEND[curexpecteddatenumber].day;

                    //A shitty hack to get the first date of the next week.
                    let startdate = expecteddurationEND[curexpecteddatenumber].month + " " + (expecteddurationEND[curexpecteddatenumber].day + 1);

                    //This is to prevent us from skipping over a design
                    //Ex. If for the week of X only 3 results are returned yet we asked for 5 results then we know to fill in the other 2 with 0's
                    let indexof = listofdesignid.indexOf(curproject);


                    let safeToPushRow = true;

                    //The first result's date should be the furthest back result, if it is not then fill it in until you hit the right result
                    while (curdate !== curenddate && curexpecteddatenumber < expecteddurationEND.length - 1) {
                        //If the very first week has 0 data then you must figure out what the start day is first or else it will fill all the slots with 0's
                        if (row.length == 0) {
                            //This should never be called more than once per chart
                            let newWeekStartDate = expecteddurationSTART[curexpecteddatenumber].month + " " + expecteddurationSTART[curexpecteddatenumber].day;
                            row.push(newWeekStartDate);

                            //console.log("First date was missing data") //DEBUG
                        }
                        while (row.length <= len) {
                            row.push(0);
                        }
                        newrowvar.push(row);
                        safeToPushRow = false;


                        row = [];
                        weekindex = 0;
                        //Updates the current week with the new week number
                        currentrowweek = curweek;
                        curexpecteddatenumber++;
                        let newWeekStartDate = expecteddurationSTART[curexpecteddatenumber].month + " " + expecteddurationSTART[curexpecteddatenumber].day;
                        row.push(newWeekStartDate);
                        //Go to the next expected date

                        curdate = expecteddurationEND[curexpecteddatenumber].month + " " + expecteddurationEND[curexpecteddatenumber].day;

                    }

                    //The week number is different, push the last row to the newrowvar and reset row
                    if (curweek !== currentrowweek && safeToPushRow) {
                        //If this is NOT the first time to loop go in this if statement
                        if (currentrowweek !== -1) {
                            //If the week changes without the last design showing up (empty set problem), fill it in with 0
                            //len is the length of the number of designs there are, aka the number of data points we should have
                            while (row.length <= len) {
                                row.push(0);
                            }
                            newrowvar.push(row);
                        }

                        row = [];
                        weekindex = 0;
                        //Updates the current week with the new week number
                        currentrowweek = curweek;
                        row.push(res.data[i].STARTDATE);
                    }

                    //indexof should NEVER be < weekindex. If so then something is wrong
                    if (indexof !== weekindex) {
                        /*
                        This will fill in the gaps for projects that have 0 hits and therefore dont show up in the API.
                        This does NOT solve whole weeks that have 0 hits. If there are 0 hits in a week then the whole week
                        won't show up.
                         */
                        while (weekindex !== indexof && !(weekindex > len)) {
                            row.push(0);
                            weekindex++;
                        }
                    }
                    //This point is reached when the weekindex==indexof
                    row.push(parseInt(res.data[i].HITS));
                    weekindex++;
                } //End forloop

                //If the above for loop ends with an incomplete row then fill it what is missing and push
                while (row.length <= len) {
                    row.push(0);
                }
                //Add the finale row to newrow var
                newrowvar.push(row);
                //Every time you push to newrowvar you will need to increase this var because it correlates to the actual week number, if you dont then you will repeat a week
                curexpecteddatenumber++;
                row = [];


                //If there is whole weeks missing then fill them in with all 0's
                let curdate = "";
                while (curexpecteddatenumber < expecteddurationEND.length - 1) {
                    let newWeekStartDate = expecteddurationSTART[curexpecteddatenumber].month + " " + expecteddurationSTART[curexpecteddatenumber].day;
                    row.push(newWeekStartDate);

                    while (row.length <= len) {
                        row.push(0);
                    }
                    newrowvar.push(row);

                    row = [];
                    //Go to the next expected date
                    curexpecteddatenumber++;
                    curdate = expecteddurationEND[curexpecteddatenumber].month + " " + expecteddurationEND[curexpecteddatenumber].day;
                }

                //Set the rows of data with the new rows
                returnobj.rows = newrowvar;

                //console.log("This is the row being pushed"); //DEBUG
                //console.log(newrowvar); //DEBUG


                /*
                !!!!!!!!!!!!!!!!!!!!!!!!!
                Start of Month conversion
                !!!!!!!!!!!!!!!!!!!!!!!!!
                 */
            } else if (monthorweek === "month") {
                //Pretty much the same logic as week^


                let newcolumn = ['Month'];
                obj.xtitle = "Month";

                let listofdesignid = [];

                if (returnobj.selectedproducts.includes("all")) {
                    for (let x of designmap.values()) {
                        newcolumn.push(x);
                    }
                    for (let x of designmap.keys()) {
                        listofdesignid.push(parseInt(x));
                    }
                } else {
                    //Adds the designs name to the columns based on ascending design id
                    returnobj.selectedproducts.forEach(x => {
                        //console.log(x);
                        listofdesignid.push(parseInt(x));
                        newcolumn.push(designmap.get(x));
                    });
                }

                //console.log(newcolumn); //DEBUG
                returnobj.columns = newcolumn;

                let monthmap = new Map([["January", "Jan"], ["February", "Feb"], ["March", "Mar"], ["April", "Apr"], ["May", "May"], ["June", "Jun"], ["July", "Jul"], ["August", "Aug"], ["September", "Sep"], ["October", "Oct"], ["November", "Nov"], ["December", "Dec"]]);
                //Len is the number of designs that are going to be looped through
                let len = listofdesignid.length;
                let monthindex = 0;

                //Newrowvar will be swapped with the obj's current data
                let newrowvar = [];
                let currentrowmonth = -1;
                //used as a tmp working row
                let row = [];

                //if there is no hits at all
                if (res.data.length === 0) {
                    let expectedmonth = monthrange[expectedmonthnumber].Month;
                    row = [];
                    row.push(monthmap.get(expectedmonth));

                    listofdesignid.forEach(() => {
                        row.push(0);
                    })
                    returnobj.rows = row;

                }
                let expectedmonthnumber = 0;
                monthrange = monthrange.reverse();
                /*
                !!!!!!!!!!!!!!
                Translate the API data to the google charts format
                 */

                for (let i = 0; i < res.data.length; i++) {
                    let curmonth = res.data[i].MONTH;
                    let curproject = res.data[i].project;
                    let curyear = res.data[i].YEAR;
                    let indexof = listofdesignid.indexOf(curproject);

                    //This represents what the next month and year should be
                    let expectedmonth = monthrange[expectedmonthnumber].Month;
                    let expectedyear = monthrange[expectedmonthnumber].Year;

                    let safeToPushRow = true;

                    //If a whole month is missing from the data
                    while (curmonth !== expectedmonth || expectedyear !== parseInt(curyear)) {
                        //If the very first Month has 0 data then you must figure out what the start day is first or else it will fill all the slots with 0's

                        if (row.length == 0) {
                            row.push(monthmap.get(expectedmonth));

                            //console.log("First date was missing data"); //DEBUG
                        }

                        while (row.length <= len) {
                            row.push(0);
                        }
                        newrowvar.push(row);
                        safeToPushRow = false;

                        row = [];
                        monthindex = 0;
                        //Updates the current month with the new month number
                        currentrowmonth = curmonth;
                        expectedmonthnumber++;

                        expectedmonth = monthrange[expectedmonthnumber].Month;
                        expectedyear = monthrange[expectedmonthnumber].Year;

                        row.push(monthmap.get(expectedmonth));

                    }


                    //The week number is different, push the last row to the newrowvar and reset row
                    if (curmonth !== currentrowmonth && safeToPushRow) {
                        if (currentrowmonth !== -1) {
                            //If the week changes wihtout the last design showing up (empty set problem), fill it in with 0
                            // <= because row should always have 1 more element in it (the date element)
                            while (row.length <= len) {
                                row.push(0);
                            }
                            newrowvar.push(row);
                        }
                        row = [];
                        monthindex = 0;
                        //Updates the current week with the new week number
                        currentrowmonth = curmonth;
                        row.push(monthmap.get(res.data[i].MONTH));
                    }

                    //indexof should NEVER be < weekindex. If so then something is wrong
                    if (indexof !== monthindex) {
                        /*
                        This will fill in the gaps for projects that have 0 hits and therefore dont show up in the API.
                        This does NOT solve whole weeks that have 0 hits. If there are 0 hits in a week then the whole week
                        won't show up.
                         */
                        while (monthindex !== indexof && !(monthindex > len)) {
                            row.push(0);
                            monthindex++;
                        }
                    }
                    //This point is reached when the monthindex==indexof
                    row.push(parseInt(res.data[i].HITS));
                    monthindex++;
                } //End forloop

                //If the above for loop ends with an incomplete row then fill it what is missing and push
                while (row.length <= len) {
                    row.push(0);
                }
                //Add the finale row to newrow var
                newrowvar.push(row);
                expectedmonthnumber++;
                row = [];

                let curmonth = "";

                while (expectedmonthnumber < monthrange.length) {
                    let expectedmonth = monthrange[expectedmonthnumber].Month;
                    row.push(monthmap.get(expectedmonth));

                    while (row.length <= len) {
                        row.push(0);
                    }
                    newrowvar.push(row);

                    row = [];
                    //Go to the next expected date
                    expectedmonthnumber++;
                    if (expectedmonthnumber < monthrange.length) {
                        curmonth = monthrange[expectedmonthnumber].Month;
                    }

                }


                returnobj.rows = newrowvar;

            }


        })
        .catch(err => {
            console.log(err);
        })
    //console.log(returnobj); //DEBUG
    //console.log("object that is filled in with new data ^") //DEBUG

    return returnobj;
}

async function gettotalviews(ID, time) {
    let timevar = "";
    if (time !== "all" && typeof time == 'number') {
        timevar = "&time=" + time;
    } else {
        //Since time is required I just put 5k days which is ~13 years
        //If we don't update this code within 13 years then we have a bigger problem -Dan, Jun 2020
        timevar = "&time=5000";
    }
    let hits = 0;
    await axios.get(baseurl + "build/stats/sum?id=" + ID + timevar)
        .then(res => {
            for (let x of res.data) {
                hits += parseInt(x.HITS);
            }
        }).catch(err => {
            console.log(err);
        })

    return hits;
}

async function gettopjursapi(ID, time, top, jurmap) {
    let timevar = "";
    let topvar = "";
    if (time !== "all" && typeof time == 'number') {
        timevar = "&time=" + time;
    } else {
        //Since the API requires a time, if the call is all then set it to 5k days ~= 13 years
        //Not PERFECT but if we don't update this code within the next 13 years we have bigger problems - Dan, June 2020
        timevar = "&time=5000"
    }

    topvar = "&top=" + top;

    let topjurs = [];

    await axios.get(baseurl + "build/stats/topjur?id=" + ID + timevar + topvar)
        .then(res => {
            //console.log(res);
            res.data.forEach(x => {
                topjurs.push(jurmap.get(x.JURISDICTION));
            })
        }).catch(err => {
            console.log(err);
            errormessage("Something went wrong while getting the top jurisdictions");
        })

    return topjurs;
}


async function saveuserchartsapi(id, charts2save, updateorinsert) {
    let charts = [];

    for (var i = 0; i < charts2save.length; i++) {
        let tmp = charts2save[i];
        tmp.columns = [];
        tmp.rows = [];

        charts.push(tmp);
    }


    axios.post(baseurl + 'users/', {
        id: id,
        method: updateorinsert,
        charts: charts
    })
        .then(function (response) {
            //console.log(response);
        })
        .catch(function (error) {
            console.log(error);
            errormessage("Error with saving the user's charts");
        });


}


async function getuserchartsapi(id) {
    var returnvar = null;
    await axios.get(baseurl + "users/" + id + "/charts")
        .then(res => {
            try {

                //If the user doesn't have charts stored then this code will run
                if (res.data.error == "Chart not found") {
                    returnvar = "no charts";
                } else {
                    returnvar = res.data;
                }
            } catch (e) {
                console.log(e);
                returnvar = res.data;
            }

        }).catch(err => {
            console.log(err);
            errormessage("Something went wrong while getting User's charts");
            returnvar = "ERROR";
        })

    return returnvar;
}
export {
  getproductsapi,
  getjurisdictionapi,
  getsinglestatapi,
  gettotalviews,
  gettopjursapi,
  saveuserchartsapi,
  getuserchartsapi
};
/*eslint-enable */
